import RedoIcon from '@mui/icons-material/Redo'
import UndoIcon from '@mui/icons-material/Undo'
import type { FC } from 'react'

import { TooltipIconButton } from 'components/TooltipIconButton'

type Props = {
  canUndo: boolean
  canRedo: boolean
  undo: () => void
  redo: () => void
}

/** The Undo / Redo icon-button pair shared by every page that offers history. */
export const UndoRedoButtons: FC<Props> = ({
  canUndo,
  canRedo,
  undo,
  redo,
}) => (
  <>
    <TooltipIconButton
      tooltipTitle="Undo (⌘Z)"
      ariaLabel="Undo"
      height={32}
      width={32}
      iconFontSize="18px"
      icon={<UndoIcon />}
      disabled={!canUndo}
      onClick={undo}
    />
    <TooltipIconButton
      tooltipTitle="Redo (⇧⌘Z)"
      ariaLabel="Redo"
      height={32}
      width={32}
      iconFontSize="18px"
      icon={<RedoIcon />}
      disabled={!canRedo}
      onClick={redo}
    />
  </>
)
